import { render } from "./PageNotFoundView.vue?vue&type=template&id=27990fab&scoped=true&ts=true"
import script from "./PageNotFoundView.vue?vue&type=script&lang=ts"
export * from "./PageNotFoundView.vue?vue&type=script&lang=ts"

import "./PageNotFoundView.vue?vue&type=style&index=0&id=27990fab&lang=scss&scoped=true"

import exportComponent from "/srv/users/dyo-frontend/apps/dyo-frontend/public_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27990fab"]])

export default __exports__